export default (build) =>
  build.mutation({
    query: ({ uid, sponsorUid, sponsoredUid }) => ({
      url: `/superadmin/sponsorship/${uid}/remove`,
      method: "DELETE",
      body: { sponsorUid, sponsoredUid },
    }),
    invalidatesTags: (result, error, { uid }) => [
      { type: "UserSponsors", id: uid },
    ],
  });
